import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { Check, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

// Menu a tendina ricercabile da tastiera (cmdk): digita per filtrare, frecce + Invio per selezionare.
// Ranking: match esatto > inizia-con > parola che inizia-con > contiene. Lo score decrescente
// fa risalire in cima il risultato più pertinente.
const rankFilter = (val, search) => {
  const label = String(val).split("\u0000")[0].toLowerCase().trim();
  const s = search.toLowerCase().trim();
  if (!s) return 1;
  if (label === s) return 100;
  if (label.startsWith(s)) return 60;
  if (label.split(/\s+/).some((w) => w.startsWith(s))) return 40;
  if (label.includes(s)) return 15;
  return 0;
};

export default function Combobox({
  value, onChange, options = [], placeholder = "Seleziona…",
  searchPlaceholder = "Cerca…", emptyText = "Nessun risultato",
  testid, className, disabled = false, triggerClassName = "", compact = false, contentClassName = "", wrap = false,
}) {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.value === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          disabled={disabled}
          className={cn(
            "flex w-full items-center justify-between border bg-white font-sans text-slate-700 transition-colors hover:border-slate-300 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-700 disabled:opacity-50",
            compact
              ? "h-7 rounded-none border-transparent px-1.5 text-[11px] hover:bg-blue-50/40"
              : "h-8 rounded-md border-slate-200 px-2.5 text-xs",
            triggerClassName, className,
          )}
        >
          <span title={selected ? selected.label : undefined} className={cn("truncate min-w-0 text-left", !selected && "text-slate-400")}>{selected ? selected.label : placeholder}</span>
          <ChevronsUpDown className={cn("ml-1 flex-shrink-0 opacity-50", compact ? "h-3 w-3" : "h-3.5 w-3.5")} />
        </button>
      </PopoverTrigger>
      <PopoverContent className={cn("w-[--radix-popover-trigger-width] min-w-[240px] p-0", contentClassName)} align="start">
        <Command filter={rankFilter}>
          <CommandInput placeholder={searchPlaceholder} className="h-9 text-xs" data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem
                  key={o.value}
                  value={`${typeof o.label === "string" ? o.label : ""}\u0000${o.value}`}
                  onSelect={() => { onChange(o.value); setOpen(false); }}
                  data-testid={testid ? `${testid}-option-${o.value}` : undefined}
                  className={cn("text-xs", o.className)}
                >
                  <Check className={cn("mr-2 h-3.5 w-3.5 flex-shrink-0", value === o.value ? "opacity-100" : "opacity-0")} />
                  <span title={typeof o.label === "string" ? o.label : undefined} className={cn(wrap ? "whitespace-normal break-words" : "truncate")}>{o.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
